<template>
  <div class="text-block" :style="blockStyle">
    <div v-html="content" :style="contentStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'TextBlock',
  props: {
    content: {
      type: String,
      default: '<p>Ingrese su texto aquí...</p>'
    },
    fontSize: {
      type: String,
      default: '16px'
    },
    color: {
      type: String,
      default: '#2c3e50'
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    textAlign: {
      type: String,
      default: 'left'
    },
    fontFamily: {
      type: String,
      default: 'Arial, sans-serif'
    },
    fontWeight: {
      type: String,
      default: '400'
    },
    lineHeight: {
      type: String,
      default: '1.5'
    },
    padding: {
      type: String,
      default: '16px'
    },
    margin: {
      type: String,
      default: '10px 0'
    },
    borderRadius: {
      type: String,
      default: '0px'
    },
    border: {
      type: String,
      default: 'none'
    }
  },
  computed: {
    blockStyle() {
      return {
        backgroundColor: this.backgroundColor,
        padding: this.padding,
        margin: this.margin,
        borderRadius: this.borderRadius,
        border: this.border,
        width: '100%',
        boxSizing: 'border-box'
      }
    },
    contentStyle() {
      return {
        fontSize: this.fontSize,
        color: this.color,
        textAlign: this.textAlign,
        fontFamily: this.fontFamily,
        fontWeight: this.fontWeight,
        lineHeight: this.lineHeight,
        margin: '0'
      }
    }
  }
}
</script>

<style scoped>
.text-block {
  width: 100%;
}

/* Estilos para elementos HTML dentro del contenido */
.text-block :deep(h1),
.text-block :deep(h2),
.text-block :deep(h3),
.text-block :deep(h4),
.text-block :deep(h5),
.text-block :deep(h6) {
  margin: 0.5em 0;
  font-weight: inherit;
}

.text-block :deep(p) {
  margin: 0.5em 0;
}

.text-block :deep(ul),
.text-block :deep(ol) {
  margin: 0.5em 0;
  padding-left: 1.5em;
}

.text-block :deep(blockquote) {
  margin: 1em 0;
  padding: 0.5em 1em;
  border-left: 4px solid #ddd;
  background: #f9f9f9;
}

.text-block :deep(a) {
  color: inherit;
  text-decoration: underline;
}

.text-block :deep(strong) {
  font-weight: bold;
}

.text-block :deep(em) {
  font-style: italic;
}
</style> 